import React from "react";
import { optionClass } from "./optionClasses";

// value: optionId (string) | undefined
const McqSingle = ({ question, value, onChange, review, correct }) => (
  <div className="flex flex-col gap-3">
    {(question.options || []).map((o) => {
      const selected = value === o._id;
      return (
        <button
          key={o._id}
          type="button"
          disabled={review}
          onClick={() => onChange(o._id)}
          className={optionClass({ selected, review, correct })}
        >
          {o.text}
        </button>
      );
    })}
  </div>
);

export default McqSingle;
